import PropTypes from 'prop-types';
import { toast as toastApi } from 'react-toastify';

import Toast from './Toast';

// To Fix the console warning of `React does not recognize the closeToast prop on a DOM element`.
// https://github.com/fkhadra/react-toastify/issues/224
const Container = (props) => {
  const { children } = props;
  return <div>{children}</div>;
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function useToast() {
  const addToast = (type, message, options = {}, iconAlt = '') => {
    const toastContent = (
      <Container>
        <Toast iconAlt={iconAlt} type={type}>
          {message}
        </Toast>
      </Container>
    );

    return toastApi(toastContent, options);
  };

  return [addToast, toastApi];
}
